import React, { useEffect, useState } from 'react';
import About from './About';
import Contact from './Contact';
import Home from './Home';
import ProductsAndServices from './ProductsAndServices';
import Solutions from './Solutions';
import Pricing from './Pricing';
import Resources from './Resources';
import SecurityAndCompliance from './SecurityAndCompliance';
import AIArtificialIntelligence from './AIArtificialIntelligence';
// import Careers from './Careers';

const MainContent = () => {
  const [scrollMarginTop, setScrollMarginTop] = useState('60px');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 575) {
        setScrollMarginTop('100px');
      } else {
        setScrollMarginTop('60px');
      }
    };

    // Initial check
    handleResize();

    // Listen for viewport resize
    window.addEventListener('resize', handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <main className="content">
      <Home MarginTop={scrollMarginTop} />
      <About MarginTop={scrollMarginTop} />
      {/* <Careers MarginTop={scrollMarginTop} /> */}
      <ProductsAndServices MarginTop={scrollMarginTop} />
      <Solutions MarginTop={scrollMarginTop} />
      <Pricing MarginTop={scrollMarginTop} />
      <Resources MarginTop={scrollMarginTop} />
      <SecurityAndCompliance MarginTop={scrollMarginTop} />
      <AIArtificialIntelligence MarginTop={scrollMarginTop} />
      <Contact MarginTop={scrollMarginTop} />
    </main>
  );
};

export default MainContent;